import { useState } from 'react'

/** Prefer SVG (reliable on mobile); fall back through PNG sizes, then an inline mark. */
const LOGO_CANDIDATES = [
  '/appy-logo.svg',
  '/appy-logo-64.png',
  '/appy-logo-256.png',
  '/appy-logo.png',
] as const

const FALLBACK_MARK =
  "data:image/svg+xml," +
  encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="none">
      <rect width="64" height="64" rx="14" fill="#111"/>
      <path d="M18 46 L32 14 L46 46 M24 34 H40" stroke="#fff" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`,
  )

export function AppyLogo({
  className = '',
  alt = 'Appy',
  decorative = false,
}: {
  className?: string
  alt?: string
  /** When true, empty alt for decorative badges */
  decorative?: boolean
}) {
  const [index, setIndex] = useState(0)
  const src = index < LOGO_CANDIDATES.length ? LOGO_CANDIDATES[index] : FALLBACK_MARK

  return (
    <img
      className={className}
      src={src}
      alt={decorative ? '' : alt}
      decoding="async"
      loading="eager"
      onError={() => setIndex((i) => i + 1)}
    />
  )
}
